<section id="tabs" class="pt-0 pb-0">
	
    <div class="row ms-0 me-0">
        <div class="col-12 ps-0 pe-0">
            <nav>
                <div class="container">
                <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link active" id="nav-denmark-tab" routerLink="/denmark" role="tab" aria-controls="nav-home" aria-selected="true">
                        <span>
                            <!-- <img src="../assets/images/icons/denmark-icon.png"> -->
                            <i class="fa fa-map-marker" aria-hidden="true"></i>DENMARK
                        </span>
                    </a>
                    <a class="nav-item nav-link" id="nav-estonia-tab" routerLink="/estonia" role="tab" aria-controls="nav-profile" aria-selected="false">
                        <span><i class="fa fa-map-marker" aria-hidden="true"></i>ESTONIA</span>
                    </a>
                    <a class="nav-item nav-link" id="nav-finland-tab" routerLink="/finland" role="tab" aria-controls="nav-contact" aria-selected="false">
                        <span><i class="fa fa-map-marker" aria-hidden="true"></i>FINLAND</span>
                    </a>
                    <a class="nav-item nav-link" id="nav-norway-tab" routerLink="/norway" role="tab" aria-controls="nav-about" aria-selected="false">
                        <span><i class="fa fa-map-marker" aria-hidden="true"></i>NORWAY</span>
                    </a>
                    <a class="nav-item nav-link" id="nav-sweden-tab" routerLink="/sweden" role="tab" aria-controls="nav-about" aria-selected="false">
                        <span><i class="fa fa-map-marker" aria-hidden="true"></i>SWEDEN</span>
                    </a>
                </div>
            </div>
            </nav>
            <div class="container">
                <div class="tab-content" id="nav-tabContent">
                    <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                        <div class="main-tab-info">
                            <div class="row">
                                <div class="col-lg-7 col-md-7">
                                    <span class="d-flex align-items-center office-loc-heading">
                                        <img src="../assets/images/icons/copenhagen-icon.png" alt="Copenhagen Icon" class="img-fluid">
                                        <h2 class="mb-0">COPENHAGEN</h2>
                                    </span>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 pe-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Office Location</p>
                                                <p class="main-addr" style="color: #3E3E3E;">Copenhagen (Headquarters)<br>
                                                Strait Air Transport A/S<br>
                                                Frederikskaj 4, 2nd floor<br>
                                                DK-2450 Copenhagen SV<br>
                                                Denmark</p>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-md-6 ps-sm-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Contact Details</p>
                                                <ul class="list-unstyled">
                                                    <li><a href="tel:4532460800"><i class="fa fa-phone" aria-hidden="true"></i>+45 32 46 08 00</a></li>
                                                    <li><a href="mailto:cph@straitair.com"><i class="fa fa-envelope" aria-hidden="true"></i>cph&#64;straitair.com</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-5 col-md-5">
                                    <!-- <img src="../assets/images/location-img.png" alt="Copenhagen" class="img-fluid"> -->
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1125.697998002344!2d12.5414182!3d55.6473211!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465253697f81d8a7%3A0x6f9abaae62ed4a6f!2sStrait%20Air%20Transport%20A%2FS!5e0!3m2!1sen!2sin!4v1693239383070!5m2!1sen!2sin" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                                </div>
                            </div>

                            <hr class="divider">

                            <div class="row">
                                <div class="col-lg-7 col-md-7">
                                    <span class="d-flex align-items-center office-loc-heading">
                                        <img src="../assets/images/icons/aalborg.png" alt="Copenhagen Icon" class="img-fluid">
                                        <h2 class="mb-0">AALBORG</h2>
                                    </span>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 pe-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Office Location</p>
                                                <p class="main-addr" style="color: #3E3E3E;">Strait Air Transport A/S <br>
                                                    Gasværksvej 5 <br>
                                                    DK-9000<br>
                                                    Aalborg<br>
                                                    Denmark</p>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-md-6 ps-sm-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Contact Details</p>
                                                <ul class="list-unstyled">
                                                    <li><a href="tel:4599334510"><i class="fa fa-phone" aria-hidden="true"></i>+45 99 33 45 10</a></li>
                                                    <li><a href="mailto:aal@straitair.com"><i class="fa fa-envelope" aria-hidden="true"></i>aal&#64;straitair.com</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-5 col-md-5">
                                    <!-- <img src="../assets/images/location-img.png" alt="Copenhagen" class="img-fluid"> -->
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1085.1268704561664!2d9.94450673087214!3d57.047196312583004!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464932bfb96ebf81%3A0xdafa945c4c84f7d0!2sStrait%20Air%20Transport!5e0!3m2!1sen!2sin!4v1669021835365!5m2!1sen!2sin" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                                </div>
                            </div>

                            <hr class="divider">

                            <div class="row">
                                <div class="col-lg-7 col-md-7">
                                    <span class="d-flex align-items-center office-loc-heading">
                                        <img src="../assets/images/icons/aarhus.png" alt="Copenhagen Icon" class="img-fluid">
                                        <h2 class="mb-0">AARHUS</h2>
                                    </span>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 pe-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Office Location</p>
                                                <p class="main-addr" style="color: #3E3E3E;">Strait Air Transport A/S <br>
                                                    Vandvejen 7 <br>
                                                    DK-8000 <br>
                                                    Aarhus C <br>
                                                    Denmark</p>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-md-6 ps-sm-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Contact Details</p>
                                                <ul class="list-unstyled">
                                                    <li><a href="tel:4586208210"><i class="fa fa-phone" aria-hidden="true"></i>+45 86 20 82 10</a></li>
                                                    <li><a href="mailto:aar@straitair.com"><i class="fa fa-envelope" aria-hidden="true"></i>aar&#64;straitair.com</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-5 col-md-5">
                                    <!-- <img src="../assets/images/location-img.png" alt="Copenhagen" class="img-fluid"> -->
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2222.856505493959!2d10.229232515505888!3d56.142294369352335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464c3fa2aa3131f1%3A0xfa4eb3081400ba97!2sStrait%20Air%20Transport%20A%2FS!5e0!3m2!1sen!2sin!4v1602138012143!5m2!1sen!2sin" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                                </div>
                            </div>

                            <hr class="divider">

                            <div class="row">
                                <div class="col-lg-7 col-md-7">
                                    <span class="d-flex align-items-center office-loc-heading">
                                        <img src="../assets/images/icons/esbjerg.png" alt="Copenhagen Icon" class="img-fluid">
                                        <h2 class="mb-0">ESBJERG</h2>
                                    </span>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 pe-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Office Location</p>
                                                <p class="main-addr" style="color: #3E3E3E;">Strait Air Transport A/S <br>
                                                    Nordre Dokkaj 1, 1st floor <br>
                                                    DK-6700 <br>
                                                    Esbjerg<br>
                                                    Denmark
                                                </p>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-md-6 ps-sm-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Contact Details</p>
                                                <ul class="list-unstyled">
                                                    <li><a href="tel:4576114518"><i class="fa fa-phone" aria-hidden="true"></i>+45 76 11 45 18</a></li>
                                                    <li><a href="mailto:ebj@straitair.com"><i class="fa fa-envelope" aria-hidden="true"></i>ebj&#64;straitair.com</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-5 col-md-5">
                                    <!-- <img src="../assets/images/location-img.png" alt="Copenhagen" class="img-fluid"> -->
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2261.5291824333744!2d8.43170211547648!3d55.47087402116835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464b20d264ba36a1%3A0x15eed3cc02d78f0b!2sStrait%20Air%20Transport!5e0!3m2!1sen!2sin!4v1602138097979!5m2!1sen!2sin" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                                </div>
                            </div>

                            <hr class="divider">

                            <div class="row">
                                <div class="col-lg-7 col-md-7">
                                    <span class="d-flex align-items-center office-loc-heading">
                                        <img src="../assets/images/icons/odense.png" alt="Copenhagen Icon" class="img-fluid">
                                        <h2 class="mb-0">ODENSE</h2>
                                    </span>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 pe-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Office Location</p>
                                                <p class="main-addr" style="color: #3E3E3E;">Strait Air Transport A/S <br>
                                                    Havnegade 34, A St. <br>
                                                    DK-5000 <br>
                                                    Odense C <br>
                                                    Denmark</p>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-md-6 ps-sm-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Contact Details</p>
                                                <ul class="list-unstyled">
                                                    <li><a href="tel:4563120420"><i class="fa fa-phone" aria-hidden="true"></i>+45 63 12 04 20</a></li>
                                                    <li><a href="mailto:ode@straitair.com"><i class="fa fa-envelope" aria-hidden="true"></i>ode&#64;straitair.com</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-5 col-md-5">
                                    <!-- <img src="../assets/images/location-img.png" alt="Copenhagen" class="img-fluid"> -->
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2265.088432966788!2d10.383101415473712!3d55.408808825937776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464ce1946647ca41%3A0x342d95f097772611!2sStrait%20Air%20Transport%20A%2FS!5e0!3m2!1sen!2sin!4v1602138154603!5m2!1sen!2sin" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                        <div class="main-tab-info">
                            <div class="row">
                                <div class="col-lg-7 col-md-7">
                                    <span class="d-flex align-items-center office-loc-heading">
                                        <img src="../assets/images/icons/estonia-icon.png" alt="Copenhagen Icon" class="img-fluid">
                                        <h2 class="mb-0">ESTONIA</h2>
                                    </span>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 pe-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Office Location</p>
                                                <p class="main-addr" style="color: #3E3E3E;">Strait Air Transport OÜ <br>
                                                    Kopli 19 <br>
                                                    10412 Tallinn <br>
                                                    Estonia</p>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-md-6 ps-sm-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Contact Details</p>
                                                <ul class="list-unstyled">
                                                    <li><a href="tel:37256957821"><i class="fa fa-phone" aria-hidden="true"></i>+372 56 957 821</a></li>
                                                    <li><a href="mailto:tll@straitair.com"><i class="fa fa-envelope" aria-hidden="true"></i>tll&#64;straitair.com</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-5 col-md-5">
                                    <!-- <img src="../assets/images/location-img.png" alt="Copenhagen" class="img-fluid"> -->
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2028.3704208416248!2d24.720561015654372!3d59.44357420889975!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4692937f0aba0755%3A0xec6772f51a94b26e!2sKopli%2019%2C%2010412%20Tallinn%2C%20Estonia!5e0!3m2!1sen!2sin!4v1602138682384!5m2!1sen!2sin" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                        <div class="main-tab-info">
                            <div class="row">
                                <div class="col-lg-7 col-md-7">
                                    <span class="d-flex align-items-center office-loc-heading">
                                        <img src="../assets/images/icons/finland-icon.png" alt="Copenhagen Icon" class="img-fluid">
                                        <h2 class="mb-0">FINLAND</h2>
                                    </span>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 pe-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Office Location</p>
                                                <p class="main-addr" style="color: #3E3E3E;">OY Strait Air Transport AB <br>
                                                    Itämerenkatu 1 <br>
                                                    FIN-00180 Helsinki <br>
                                                    Finland</p>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-md-6 ps-sm-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Contact Details</p>
                                                <ul class="list-unstyled">
                                                    <li><a href="tel:35898254520"><i class="fa fa-phone" aria-hidden="true"></i>+358 9 825 4520</a></li>
                                                    <li><a href="mailto:hel@straitair.com"><i class="fa fa-envelope" aria-hidden="true"></i>hel&#64;straitair.com</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-5 col-md-5">
                                    <!-- <img src="../assets/images/location-img.png" alt="Copenhagen" class="img-fluid"> -->
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1985.162906049098!2d24.90266241568756!3d60.16148195106481!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46920a4f46d4dce5%3A0xc244a1f1e39199f8!2sOy%20Strait%20Air%20Transport%20Ab!5e0!3m2!1sen!2sin!4v1602139169565!5m2!1sen!2sin" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="nav-about" role="tabpanel" aria-labelledby="nav-about-tab">
                        <div class="main-tab-info">
                            <div class="row">
                                <div class="col-lg-7 col-md-7">
                                    <span class="d-flex align-items-center office-loc-heading">
                                        <img src="../assets/images/icons/norway-icon.png" alt="Copenhagen Icon" class="img-fluid">
                                        <h2 class="mb-0">NORWAY</h2>
                                    </span>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 pe-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Office Location</p>
                                                <p class="main-addr" style="color: #3E3E3E;">Strait Air Transport AS <br>
                                                    Granfos Naeringspark <br>
                                                    Vollsveien 13C <br>
                                                    N-1366 Lysaker <br>
                                                    Norway</p>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-md-6 ps-sm-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Contact Details</p>
                                                <ul class="list-unstyled">
                                                    <li><a href="tel:4763943080"><i class="fa fa-phone" aria-hidden="true"></i>+47 63 94 30 80</a></li>
                                                    <li><a href="mailto:osl@straitair.com"><i class="fa fa-envelope" aria-hidden="true"></i>osl&#64;straitair.com</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-5 col-md-5">
                                    <!-- <img src="../assets/images/location-img.png" alt="Copenhagen" class="img-fluid"> -->
                                    <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d255089.31110428908!2d10.628389241242528!3d60.03355507575813!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46416cfb420c0139%3A0xaff2b0d884787967!2sGranfos%20N%C3%A6ringspark!5e0!3m2!1sen!2sin!4v1602139630180!5m2!1sen!2sin" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe> -->
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1999.9273532338007!2d10.6299735!3d59.916753!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46416cfcbb87a6b5%3A0xd9ecab03eae73e36!2sVollsveien%2013C%2C%201366%20Lysaker%2C%20Norway!5e0!3m2!1sen!2sin!4v1618824649138!5m2!1sen!2sin" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="tab-pane fade" id="nav-sweden" role="tabpanel" aria-labelledby="nav-sweden-tab">
                        <div class="main-tab-info">
                            <div class="row">
                                <div class="col-lg-7 col-md-7">
                                    <span class="d-flex align-items-center office-loc-heading">
                                        <img src="../assets/images/icons/sweden-icon.png" alt="Copenhagen Icon" class="img-fluid">
                                        <h2 class="mb-0">SWEDEN</h2>
                                    </span>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 pe-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Office Location</p>
                                                <p class="main-addr" style="color: #3E3E3E;">                                                
                                                    Strait Air Transport AB <br>
                                                    Föreningsgatan 21 <br>
                                                    Box 2068 <br>
                                                    SE-403 12 <br>
                                                    Gothenburg <br>
                                                    Sweden
                                                </p>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-md-6 ps-sm-0">
                                            <div class="cust-col-1">
                                                <p class="border-bottom pb-3">Contact Details</p>
                                                <ul class="list-unstyled">
                                                    <li><a href="tel:460317971580"><i class="fa fa-phone" aria-hidden="true"></i>+46 0 31 797 15 80</a></li>
                                                    <li><a href="mailto:got@straitair.com"><i class="fa fa-envelope" aria-hidden="true"></i>got&#64;straitair.com</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-5 col-md-5">
                                    <!-- <img src="../assets/images/location-img.png" alt="Copenhagen" class="img-fluid"> -->
                                    <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d272884.0978476551!2d11.613655778527566!3d57.7010495771246!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464f8e67966c073f%3A0x4019078290e7c40!2sGothenburg%2C%20Sweden!5e0!3m2!1sen!2sin!4v1602139720319!5m2!1sen!2sin" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe> -->
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2132.270699263375!2d11.96354761557497!3d57.694870648014806!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464ff36da8f24cd5%3A0x3706f0e7e6af78d4!2sF%C3%B6reningsgatan%2021%2C%20411%2027%20G%C3%B6teborg%2C%20Sweden!5e0!3m2!1sen!2sin!4v1603882174446!5m2!1sen!2sin" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        
        </div>
    </div>

</section>
